'use client';

import { initFaro } from '@/lib/faro';
import { useEffect } from 'react';

export function FaroProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initFaro();
  }, []);

  return <>{children}</>;
}
